// Getekende beweging: een element met [data-in-beeld] krijgt één keer de klasse
// is-in-beeld zodra het in beeld komt. De CSS doet de rest (tekeningen die
// zichzelf tekenen, een stapel die zich schikt). Zonder JavaScript, of met
// prefers-reduced-motion, staat alles gewoon af in zijn rusttoestand.

export default function maakInBeeld() {
    const elementen = document.querySelectorAll('[data-in-beeld]');
    if (!elementen.length) return;

    const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (rustig || !('IntersectionObserver' in window)) {
        elementen.forEach((el) => el.classList.add('is-in-beeld'));
        return;
    }

    // Pas als de observer klaarstaat mogen de startstanden (onzichtbare lijnen) gelden.
    document.documentElement.classList.add('js-in-beeld');

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-in-beeld');
            observer.unobserve(entry.target);
        }
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

    elementen.forEach((el) => observer.observe(el));
}
